// Modèles : remonte la première carte fichier sous le titre (compte-rendu, arrêté), montre la prochaine date d'un événement et génère son .ics.
import { lireDate, trierDates } from "./rdv";
export default function template() {
    // Document officiel : la première carte Fichier du texte va en fin de texte (sous l'encadré « seul le document joint fait foi »),
    // et un lien discret sous le titre y mène (Compte-rendu, Arrêté, fiches de référence).
    const slot = document.querySelector("[data-pdf-slot]");
    const corps = document.querySelector(".article-body");
    if (slot && corps) {
        const fichier = corps.querySelector(".kg-file-card");
        if (fichier) {
            fichier.id = "document-officiel";
            const fin = corps.querySelector("[data-fin-contenu]");
            if (fin) corps.insertBefore(fichier, fin); else corps.appendChild(fichier);
            const lien = slot.querySelector("[data-pdf-lien]");
            const titre = (fichier.querySelector(".kg-file-card-title")?.textContent || "").trim();
            const taille = (fichier.querySelector(".kg-file-card-filesize")?.textContent || "").trim();
            if (lien) lien.textContent = `Document officiel : ${titre || "PDF"}${taille ? ` (PDF, ${taille})` : ""}`;
            slot.hidden = false;
        }
    }

    const ev = document.querySelector("[data-evenement]");
    const bouton = ev && ev.querySelector("[data-ics]");
    if (!ev || !bouton) return;

    // Plusieurs dates : le bloc et l'horaire de la prochaine date à venir sont montrés, la liste marque les dates passées
    const blocs = [...ev.querySelectorAll(".d[data-date]")];
    const { tous, futurs, choisi } = trierDates(blocs);
    if (choisi) {
        blocs.forEach((el) => { el.hidden = el !== choisi.el; });
        ev.querySelectorAll(".quand[data-date]").forEach((el) => { el.hidden = el.dataset.date !== choisi.el.dataset.date; });
    }
    const maintenant = new Date();
    ev.querySelectorAll(".dates li[data-date]").forEach((li) => {
        const d = lireDate(li.dataset.date);
        if (d && d < maintenant) { li.classList.add("passee"); li.insertAdjacentHTML("beforeend", '<span class="sr"> (date passée)</span>'); }
        else if (choisi && li.dataset.date === choisi.el.dataset.date) li.setAttribute("aria-current", "date");
    });

    // .ics : une entrée par date à venir (toutes si l'événement est passé)
    const parse = (s) => /(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?:-(\d{1,2}):(\d{2}))?)?/.exec(s || "");
    const sources = (futurs.length ? futurs : tous).map((x) => parse(x.el.dataset.date)).filter(Boolean);
    if (!sources.length) return;
    bouton.hidden = false;
    if (sources.length > 1) bouton.textContent = `Ajouter les ${sources.length} dates à mon agenda`;
    bouton.addEventListener("click", () => {
        const pad = (n) => String(n).padStart(2, "0");
        const echap = (s) => (s || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
        const lien = document.querySelector('link[rel="canonical"]')?.href || location.href.split("#")[0];
        const estampille = `${new Date().getFullYear()}${pad(new Date().getMonth() + 1)}${pad(new Date().getDate())}T000000Z`;
        const lignes = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//maizeroy.fr//theme maizeroy//FR"];
        sources.forEach((m, i) => {
            const journee = !m[4];
            const debut = new Date(+m[3], +m[2] - 1, +m[1], m[4] ? +m[4] : 0, m[5] ? +m[5] : 0);
            // Fin : heure de fin si indiquée (« 20:00-20:30 »), sinon deux heures (journée : le lendemain)
            const fin = m[6] ? new Date(+m[3], +m[2] - 1, +m[1], +m[6], +m[7]) : new Date(debut.getTime() + (journee ? 86400000 : 7200000));
            const fmt = (d) => journee ? `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}` : `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
            lignes.push("BEGIN:VEVENT",
                `UID:${Date.now()}-${i}@maizeroy.fr`,
                `DTSTAMP:${estampille}`,
                journee ? `DTSTART;VALUE=DATE:${fmt(debut)}` : `DTSTART:${fmt(debut)}`,
                journee ? `DTEND;VALUE=DATE:${fmt(fin)}` : `DTEND:${fmt(fin)}`,
                `SUMMARY:${echap(ev.dataset.titre)}`,
                ev.dataset.lieu ? `LOCATION:${echap(ev.dataset.lieu.trim())}` : null,
                `URL:${lien}`,
                `DESCRIPTION:${echap(lien)}`,
                "END:VEVENT");
        });
        lignes.push("END:VCALENDAR");
        const blob = new Blob([lignes.filter(Boolean).join("\r\n")], { type: "text/calendar;charset=utf-8" });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "evenement.ics";
        document.body.appendChild(a);
        a.click();
        setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
    });
}
